import React from 'react';

const CTA = () => null;

export default CTA;
